import React, { FC } from 'react';

import { IconProps } from 'types/components';

import Icon from './Icon';

const ArrowUp: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path d="M12 20a1 1 0 0 1-1-1V5a1 1 0 0 1 2 0v14a1 1 0 0 1-1 1Z" />
    <path d="M18 12a1 1 0 0 1-.71-.29l-6-6a1 1 0 0 1 1.42-1.42l6 6a1 1 0 0 1 0 1.42A1 1 0 0 1 18 12Z" />
    <path d="M6 12a1 1 0 0 1-.71-.29 1 1 0 0 1 0-1.42l6-6a1 1 0 1 1 1.42 1.42l-6 6A1 1 0 0 1 6 12Z" />
  </Icon>
);

export default ArrowUp;
